import Vue from 'vue'
import App from './App.vue'
import router from './router' // 路由设置
import { setRem } from './plugin/rem/rem'
import fetch from './plugin/axios/fetch'
import store from './store/index'
// 移动端调试vConsole
// 需要启动移动端调试，在url上加上vConsole=true即可
import VConsole from 'vconsole'
// import vConsole from './libs/vconsole'
// 选择是否使用vuex状态管理
// import store from './store/index'
import { setWXConfigParams } from './plugin/wxSdk'

// 全局指令
import * as directives from './plugin/directive/index.js'
import filters from './plugin/filters/index'
// 页面动画依赖vuex, 如果需要页面过渡，请务必使用vuex状态管理
// 关闭页面过渡动画, 默认开启
// store.dispatch('appShell/disablePageTransition')
import { Popup, Toast, MessageBox } from 'mint-ui'
import emsMsgBox from '@/components/messageBox'
import tipTopup from '@/components/tipTopup'
import { PostUiIcon } from '@/plugin/postUiIcon'
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.prototype.PostUiIcon = PostUiIcon
Vue.component(Popup.name, Popup)
Vue.component(MessageBox.name, MessageBox)
Vue.use(emsMsgBox)
Vue.use(tipTopup)
// Vue.use(Toast)
Object.defineProperty(Vue.prototype, '$toast', { value: Toast })
Object.defineProperty(Vue.prototype, '$fetch', { value: fetch })

if (process.env.VUE_APP_NODE_ENV !== 'production') {
  // vConsole()
  Vue.use(new VConsole())
}

// rem
setRem(document, window)
Vue.config.productionTip = false
setWXConfigParams() // 微信配置
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
